{
  "CHAT_LIST": {
    "LOADING": "Đang tải các cuộc trò chuyện",
    "LOAD_MORE_CONVERSATIONS": "Tải thêm các cuộc trò chuyện",
    "EOF": "Tất cả các cuộc trò chuyện đã được tải 🎉",
    "LIST": {
      "404": "Không có bất kì hoạt động trò chuyện nào trong nhóm."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Các cuộc hội thoại",
    "MENTION_HEADING": "Nhắn đến",
    "UNATTENDED_HEADING": "Không giám sát",
    "SEARCH": {
      "INPUT": "Tìm kiếm cho người, đoạn chat, lưu trữ trả lời .."
    },
    "SEARCH_MESSAGES": "Tìm kiếm cuộc trò chuyện",
    "SEARCH_INPUT_PLACEHOLDER": "Tìm kiếm cuộc trò chuyện...",
    "FILTER_ALL": "Tất cả",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Của tôi",
      "unassigned": "Chưa được phân công",
      "all": "Tất cả"
    },
    "MESSAGE_USE_AS_TEMPLATE": "Dán vào câu trả lời",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Mở",
        "BUY": "Mua"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Mở"
      },
      "resolved": {
        "TEXT": "Đã được giải quyết"
      },
      "pending": {
        "TEXT": "Chờ giải quyết"
      },
      "snoozed": {
        "TEXT": "Tạm dừng"
      },
      "all": {
        "TEXT": "Tất cả"
      }
    },
    "VIEW_FILTER": "Xem",
    "SORT_TOOLTIP_LABEL": "Sort conversations",
    "CHAT_SORT": {
      "STATUS": "Trạng thái",
      "ORDER_BY": "Order by"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Đã tạo",
      "LAST_ACTIVITY": "Last activity:",
      "LAST_CUSTOMER_MESSAGE": "Tin nhắn khách hàng gần nhất:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Tin nhắn khách hàng gần nhất: Cũ nhất trước"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Tin nhắn khách hàng gần nhất: Mới nhất trước"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "priority_created_at_desc": {
        "TEXT": "Độ ưu tiên + Ngày tạo: Mới nhất trước"
      },
      "priority_created_at_asc": {
        "TEXT": "Độ ưu tiên + Ngày tạo: Cũ nhất trước"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Tin nhắn hình ảnh"
      },
      "audio": {
        "CONTENT": "Tin nhắn thoại"
      },
      "video": {
        "CONTENT": "Tin nhắn video"
      },
      "file": {
        "CONTENT": "Tập tin đính kèm"
      },
      "location": {
        "CONTENT": "Địa điểm"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "có một đường dẫn chia sẻ"
      },
      "contact": {
        "CONTENT": "Shared contact"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sort conversation",
      "DROPDOWN_TITLE": "Sắp bởi",
      "ITEMS": {
        "LATEST": {
          "NAME": "Last activity at",
          "LABEL": "Last activity"
        },
        "CREATED_AT": {
          "NAME": "Tạo vào lúc",
          "LABEL": "Tạo vào lúc"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Last user message at",
          "LABEL": "Last message"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Nhận được từ email",
    "VIEW_TWEET_IN_TWITTER": "Xem tweet trên Twitter",
    "REPLY_TO_TWEET": "Trả lời cho tweet này",
    "LINK_TO_STORY": "Đến xem lịch sử instagram",
    "SENT": "Gửi thành công",
    "READ": "Đọc thành công",
    "DELIVERED": "Đã gửi thành công",
    "NO_MESSAGES": "Không có tin nhắn",
    "NO_CONTENT": "Không có nội dung",
    "HIDE_QUOTED_TEXT": "Ẩn văn bản được trích dẫn",
    "SHOW_QUOTED_TEXT": "Hiện Văn bản được trích dẫn",
    "HIDE_AUTOMATED_MESSAGE": "Ẩn nội dung trả lời tự động",
    "SHOW_AUTOMATED_MESSAGE": "Hiện nội dung trả lời tự động",
    "AUTOMATED_MESSAGE": "Trả lời tự động",
    "MESSAGE_READ": "\bĐọc",
    "SENDING": "Sending"
  }
}
